// Toast notification system — call showToast(...) from anywhere (no hooks,
// no context needed at the call site) to display a dismissible, auto-fading
// notification. <ToastContainer /> (mounted once, in main.jsx's Root so
// it's available on every page) subscribes to this and renders the actual
// UI, including the fade-out timing — this file is just the data registry.

let listeners = new Set();
let toasts = [];
let nextId = 1;

export function showToast(message, type = "success") {
  const id = nextId++;
  toasts = [...toasts, { id, message, type }];
  listeners.forEach((fn) => fn(toasts));
  return id;
}

export function dismissToast(id) {
  toasts = toasts.filter((t) => t.id !== id);
  listeners.forEach((fn) => fn(toasts));
}

export function subscribeToasts(fn) {
  listeners.add(fn);
  fn(toasts);
  return () => listeners.delete(fn);
}
